import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'formly-form-flex',
  template: `
    <div
      [ngClass] = getNgClass()
      [fxLayout] = "to.fxLayout" 
      [fxLayoutAlign] = "to.fxLayoutAlign" 
      fxFlexFill
    >
      <formly-field *ngFor = "let f of field.fieldGroup; even as even;" 
        [field] = "f" [fxFlex] = "f.templateOptions!.fxFlex" [ngClass] = "f.className!">
      </formly-field>
    </div>
  `,
  styleUrls: ['./flex-layout.type.css']
  
})

export class FlexLayoutType extends FieldType<any> {

  getNgClass(): any {
    let obj: any = {
      'formly-form-flex': true
    };
    if (this.to.className) {
      obj[this.to.className] = true;
    }
    return obj;
  }
}